import { useTranslations } from 'next-intl'

export interface RatingDistributionProps {
  reviewTotal: number
  reviewsByStars: Record<string, number>
  isLoading: boolean
}

export function RatingDistribution({
  reviewsByStars,
  reviewTotal,
  isLoading,
}: RatingDistributionProps) {
  const t = useTranslations('prod.product_description_page.reviews')
  return (
    <table className="text-cf-dreamy-cloud-900 grow border-separate">
      <tbody>
        {Object.entries(reviewsByStars)
          .toReversed()
          .map(([star, count], index) => (
            <tr key={star}>
              <td className="whitespace-nowrap pb-5 pr-4 font-semibold underline">
                {star === '1'
                  ? t('star_number', {
                      number: star,
                    })
                  : t('stars_number', {
                      number: star,
                    })}
              </td>
              <td className="w-full pb-6 pr-4">
                <progress
                  id={`progress_${index + 1}_stars`}
                  max="100"
                  value={reviewTotal ? (count / reviewTotal) * 100 : 0}
                  className="hidden"
                />
                <div className="bg-cf-dreamy-cloud-400 relative h-3 w-full overflow-hidden rounded-full">
                  <div
                    className="h-full bg-[#F9A050]"
                    style={{
                      width: `${reviewTotal ? (count / reviewTotal) * 100 : 0}%`,
                    }}
                  />
                </div>
              </td>
              <td className="whitespace-nowrap pb-6 text-[14px]">
                {isLoading ? (
                  <span className="bg-cf-dreamy-cloud-500 inline-block h-3 w-6 animate-pulse" />
                ) : (
                  count.toLocaleString('en-US')
                )}{' '}
                {isLoading
                  ? null
                  : `(${Math.round(reviewTotal ? (count / reviewTotal) * 100 : 0)}%)`}
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  )
}
